export default function WhatThisIs() {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-xs font-bold tracking-widest uppercase text-pink-500 mb-4 block">
              What This Is
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-8">
              Built for real life.<br />Right here, locally.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              The Mommy Mingle is a local community built for real life — helping moms find their people, plan their days, and actually enjoy motherhood.
            </p>
            <p className="text-base text-gray-500 leading-relaxed mb-4">
              This is a space for moms of all backgrounds, seasons, and walks of life.
            </p>

            <p className="text-sm text-gray-400 italic mb-10">
              Trusted by local moms and businesses across Gwinnett and surrounding areas.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {[
                { icon: 'ri-community-line', label: 'Community Hub', desc: 'Real local connections' },
                { icon: 'ri-map-2-line', label: 'Resource Hub', desc: 'Local help when needed' },
                { icon: 'ri-calendar-check-line', label: 'Event Hub', desc: 'Things to do nearby' },
              ].map((item) => (
                <div key={item.label} className="flex flex-col gap-2">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl text-pink-500`}></i>
                  </div>
                  <p className="text-sm font-bold text-gray-900">{item.label}</p>
                  <p className="text-xs text-gray-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="relative h-[500px] w-full rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/1aca6b11057edd68794f9319fe4eecaa.jpg"
                alt="Moms connecting in the community"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-5 border border-gray-100 w-52">
              <p className="text-3xl font-extrabold text-gray-900 leading-none">1,000+</p>
              <p className="text-sm text-gray-500 mt-1">local moms across Gwinnett</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
